// extracted by mini-css-extract-plugin
export default {"container":"Sports_container__JKiGZ","sports":"Sports_sports__2gLG5"};